module.exports = __webpack_public_path__ + "img/1544150838.46e12ec7.jpg";